module.exports = "/images/file.svg?cf76a379d53196bae757b1c3836609ab";